import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {Box, Dialog} from '@material-ui/core';
import NewForm from './NewForm';

const styles = (theme) => ({
  root: {
    margin: 0,
    // padding: theme.spacing(4),
    color: '#FFF',
    borderBottom: '1px solid #ffffff8a',
    alignItems: 'center',
    padding: 20,
  },

  closeButton: {
    'position': 'absolute',
    'right': 18,
    'top': 18,
    'color': '#000',
    'width': 20,
    'height': 20,
    'backgroundColor': '#F8F8F8',
    '&:hover, &:focus, &.active': {
      backgroundColor: '#F8F8F8',
      outline: 'none',
    },
  },
  heading: {
    fontSize: 16,
    color: '#fff',
    fontWeight: 500,
    // backgroundColor: 'linear-gradient(#7C7AFC, #7876f7)',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.5rem',
    },
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <div className="themeColor">
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <div className={classes.heading}>{children}</div>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    </div>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '15px',
    backgroundColor: 'rgb(239 239 239 / 0.75)',
  },
}))(MuiDialogContent);

export default function Add2({handleModalClose, open}) {
  const handleClose = () => {
    handleModalClose();
  };

  return (
    <Box>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth={'md'}
        button2Text="Save"
        button1Text="Cancel"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Widget Settings
        </DialogTitle>
        <div className="settings-theme">
          <DialogContent>
            <NewForm handleClose={handleClose} />
          </DialogContent>
        </div>
      </Dialog>
    </Box>
  );
}
